// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, loginClient } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitLoginClientApi = createAsyncThunk(
  "hitLoginClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + loginClient;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      showToast(error.response.data.message, "error");
      throw error.response.data;
    }
  }
);

const loginClientSlice = createSlice({
  name: "loginClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitLoginClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitLoginClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitLoginClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        if (
          action.payload?.status == true &&
          action.payload?.data?.accessToken
        ) {
          localStorage.setItem("clientToken", action.payload.data.accessToken);
          localStorage.setItem("clientId", action.payload.data._id);
          localStorage.setItem(
            "clientData",
            JSON.stringify(action.payload.data)
          );
        }
      })
      .addCase(hitLoginClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitLoginClientData } = loginClientSlice.actions;
export default loginClientSlice.reducer;
